import React from 'react';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('GoalWithoutThreshold', () => ({
  amount: {
    flex: 2,
    textAlign: 'end',
  },
  timing: {
    flex: 1,
    textAlign: 'end',
  },
}));

export const GoalWithoutThreshold = ({ resource, prefix }) => {
  const classes = useStyles();
  return (
    <FDStack
      direction={'row'}
      spacing={2}
      justifyContent={'space-between'}
      alignItems={'center'}
    >
      {prefix ?? null}
      <FDBodyText flex={4} size={'md'} value={resource.attr('label')} {...dataAttrs('goal-name')} />
      <div className={classes.amount}><FDBodyText size={'md'} value={resource.attr('amount')} /></div>
      <div className={classes.timing}><FDBodyText size={'md'} value={resource.attr('timing')} /></div>
    </FDStack>
  );
};
